/* The same round buttons as the testimonials rail's. */
.arrows {
  display: flex;
  flex: none;
  gap: var(--sp-3);
}
.arrow {
  display: grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid var(--border);
  border-radius: 50%;
  background: var(--surface-raised);
  color: var(--text-strong);
  font-size: var(--fs-lg);
  line-height: 1;
  transition:
    border-color var(--dur) var(--ease),
    background-color var(--dur) var(--ease),
    opacity var(--dur) var(--ease);
}
.arrow:hover:not([aria-disabled="true"]) {
  border-color: var(--accent);
  background: var(--surface-hover);
}
/* Nothing further that way: still visible, so the pair always reads as a control. */
.arrow[aria-disabled="true"] {
  opacity: 0.4;
  cursor: default;
}
